import { useQuery } from "@tanstack/react-query";

import api from "../core/api";

export const useTagQuery = (tagId?: string) => {
  return useQuery({
    queryKey: ["tags", tagId],
    queryFn: () => api.tags.getTag(tagId!),
    enabled: !!tagId,
  });
};
